import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ExportModal from '../CanvasMap/components/ExportModal';

const Toolbar = ({ 
    onEditToggle, 
    isEditing,
    showReuploadControls,
    showResizeControls,
    setShowReuploadControls,
    setShowResizeControls
}) => {
    const [activeTool, setActiveTool] = useState(null);

    const handleToolClick = (tool) => {
        // If clicking the same tool, deactivate it
        if (activeTool === tool) {
            setActiveTool(null);
            if (tool === 'draw') onEditToggle();
            if (tool === 'file') setShowReuploadControls(false);
            if (tool === 'resize') setShowResizeControls(false);
        } else {
            // Deactivate current tool
            if (activeTool === 'draw') onEditToggle();
            if (activeTool === 'file') setShowReuploadControls(false);
            if (activeTool === 'resize') setShowResizeControls(false);
            
            // Activate new tool
            setActiveTool(tool);
            if (tool === 'draw') onEditToggle();
            if (tool === 'file') setShowReuploadControls(true);
            if (tool === 'resize') setShowResizeControls(true);
        }
    };
  
    return (
        <div style={{
            backgroundColor: '#343a40',
            color: 'white',
            padding: '10px 20px',
            borderRadius: '9999px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            display: 'flex',
            alignItems: 'center',
            height: '50px',
            minWidth: '200px'
        }}>
            <Container style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                justifyContent: 'center'
            }}>
                <button 
                    onClick={() => handleToolClick('file')}
                    style={{
                        padding: '6px 12px',
                        background: activeTool === 'file' ? '#4a86e8' : 'transparent',
                        color: 'white',
                        border: '1px solid white',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    File
                </button>

                <button 
                    onClick={() => handleToolClick('draw')}
                    style={{
                        padding: '6px 12px',
                        background: activeTool === 'draw' ? '#4a86e8' : 'transparent',
                        color: 'white',
                        border: '1px solid white',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Draw
                </button>

                <button
                    onClick={() => handleToolClick('resize')}
                    style={{
                        padding: '6px 12px',
                        background: activeTool === 'resize' ? '#4a86e8' : 'transparent',
                        color: 'white',
                        border: '1px solid white',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Resize
                </button>
            </Container>
        </div>
    );
};

export default Toolbar; 